module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/name/prefix.js
// module id = 2538
// module chunks = 1610